<template>
    <div class="container">
        <Progress :stage="4"/>
        <div class="section-paragraph" v-if="language==='zh'" v-html="hotelContent"></div>
        <div class="section-paragraph" v-if="language==='en'" v-html="hotelContentEn"></div>
        <a-form @submit="handleSubmit" :form="form" class="hotel-form">
            <a-row>
                <a-col :span="15">
                    <a-form-item
                        :label="getLabel('HOTEL_LABEL5')"
                        :labelCol="{ span: language === 'zh' ? 5 : 7 }"
                        :wrapperCol="{ span: language === 'zh' ? 19 : 17 }"
                    >
                        <a-locale-provider :locale="language === 'zh' ? zhCN : en_US">
                            <a-date-picker
                                size="large"
                                :allowClear="false"
                                :placeholder="getLabel('HOTEL_LABEL1')"
                                :defaultPickerValue="hotelCheckInDate ? moment(hotelCheckInDate, 'YYYY-MM-DD') : moment()"
                                v-decorator="['checkin_date', {rules: [{ required: true, message: getLabel('HOTEL_LABEL1')}]}]" style="width: 100%">
                                <span slot="suffixIcon" class="common-calender"></span>
                            </a-date-picker>
                        </a-locale-provider>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="15">
                    <a-form-item
                        :label="getLabel('HOTEL_LABEL6')"
                        :labelCol="{ span: language === 'zh' ? 5 : 7 }"
                        :wrapperCol="{ span: language === 'zh' ? 19 : 17 }"
                    >
                        <a-locale-provider :locale="language === 'zh' ? zhCN : en_US">
                            <a-date-picker
                                size="large"
                                :allowClear="false"
                                :placeholder="getLabel('HOTEL_LABEL2')"
                                :defaultPickerValue="hotelCheckOutDate ? moment(hotelCheckOutDate, 'YYYY-MM-DD') : moment()"
                                v-decorator="['checkout_date', {rules: [{ required: true, message: getLabel('HOTEL_LABEL2')}]}]" style="width: 100%">
                                <span slot="suffixIcon" class="common-calender"></span>
                            </a-date-picker>
                        </a-locale-provider>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-form-item
                    :label="getLabel('HOTEL_LABEL3')"
                    :labelCol="{ span: language === 'zh' ? 2 : 3 }"
                    :wrapperCol="{ span: language === 'zh' ? 22 : 19 }"
                    style="margin-left: -10px;"
                >
                    <a-input
                        v-decorator="['remark', {rules: []}]"
                        :placeholder="getLabel('HOTEL_LABEL4')"
                        size="large"/>
                </a-form-item>
            </a-row>
            <div class="btn-group">
                <a-button type='default' size="large" @click="backToSummary" v-if="isSecondEnter">{{getLabel('TIP_CANCEL')}}</a-button>
                <a-button type='primary' size="large" class="btn-orange" @click="prevStep" v-if="!isSecondEnter">{{getLabel('BUTTON_PREV')}}</a-button>
                <a-button type='default' size="large" @click="skipStep" v-if="!isSecondEnter">{{getLabel('BUTTON_SKIP')}}</a-button>
                <a-button type='primary' size="large" htmlType='submit'>{{getLabel('BUTTON_NEXT')}}</a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Progress from '../components/Progress';
	import Language from '../util/language';
	import { washData } from '../util/tools'
	import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
	import en_US from 'ant-design-vue/lib/locale-provider/en_US';
	import moment from 'moment';
    import Controller from '../components/Controller';

	export default {
		components: {
			Progress
		},
        mixins: [Controller],
		data () {
			return {
				form: this.$form.createForm(this),
				zhCN,
                en_US,
				moment
			}
		},
		mounted() {
			if (!this.hasData) {
				this.$store.dispatch('hotel/getHotel');
			} else {
				this.form.setFieldsValue(this.formatInputDate(this.hotelObj));
			}
		},
		computed: {
			...mapState({
				language: state => state.main.language,
				hasData: state => state.hotel.hasData,
				hotelObj: state => state.hotel.hotelObj,
				isSecondEnter: state => state.main.isSecondEnter,
				is_lecture: state => state.main.currentUser.is_lecture,
                hotelContent: state => state.main.hotel_content,
                hotelContentEn: state => state.main.hotel_content_en,
                hotelCheckInDate: state => state.main.hotel_checkin_date,
                hotelCheckOutDate: state => state.main.hotel_checkout_date
			})
		},
		watch: {
			hasData: function () {
				this.form.setFieldsValue(this.formatInputDate(this.hotelObj));
			}
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
            // 展示时间格式转化
            formatInputDate: function (srcDate) {
				srcDate = JSON.parse(JSON.stringify(srcDate));
				const checkin_date = srcDate['checkin_date'];
	            const checkout_date = srcDate['checkout_date'];
				if (checkin_date) {
					srcDate['checkin_date'] = moment(checkin_date, 'YYYY-MM-DD');
                } else {
					srcDate['checkin_date'] = null;
                }
	            if (checkout_date) {
		            srcDate['checkout_date'] = moment(checkout_date, 'YYYY-MM-DD');
	            } else {
		            srcDate['checkout_date'] = null;
	            }
				return srcDate;
            },
            // 提交时间格式化
            formatSubmitDate: function (submitData) {
	            const checkin_date = submitData['checkin_date'];
	            const checkout_date = submitData['checkout_date'];
	            if (checkin_date) {
		            submitData['checkin_date'] = checkin_date.format('YYYY-MM-DD');
	            }
	            if (checkout_date) {
		            submitData['checkout_date'] = checkout_date.format('YYYY-MM-DD');
	            }
				return submitData;
            },
			// 上一步
			prevStep: function () {
				if (this.language === 'zh') {
					this.$router.push('/flight');
				} else {
					this.$router.push('/en/flight');
				}
			},
			// 跳过
			skipStep: function () {
				this.submitHotelInfo(this.form.getFieldsValue());
			},
			// 下一步
			handleSubmit: function (e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
                        this.submitHotelInfo(values);
					}
				})
			},
            // 提交
            submitHotelInfo: function (data) {
				data = washData(data);
	            let checkin_date = data['checkin_date'];
	            let checkout_date = data['checkout_date'];
	            if (checkin_date && checkout_date) {
	            	checkin_date = (new Date(checkin_date)).getTime();
	            	checkout_date = (new Date(checkout_date)).getTime();
	            	if (checkin_date >= checkout_date) {
	            		this.$store.commit('main/openMessage', {
				            type: 'warning',
				            message: this.getLabel('HOTEL_TIP')
			            }, { root: true });
	            		return;
                    }
                }
                data = this.formatSubmitDate(data);
	            this.$store.dispatch('hotel/submitHotelInfo', {
	                data,
                    cb: this.nextPage
                });
            },
			backToSummary: function () {
				this.$store.commit('main/backToSummary');
			}
		}
	};
</script>

<style lang="less" scoped>
    .hotel-form {
        margin-top: 10px;
        padding-top: 30px;
        padding-left: 20px;
        background: url(../assets/img/hotel.png) right 160px top no-repeat;
    }
</style>
<style lang="less">
    .hotel-form .ant-form-item-label label{
        color: #333;
    }
</style>
